
import { Button } from '../../../components/base/Button';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation();
  
  const scrollToReserve = () => {
    const element = document.getElementById('reserve');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/ffe30bd18b7c23c007be955306c395ab.jpg')`
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Small Label */}
          <div className="inline-block mb-6">
            <span className="bg-white/95 text-primary-600 px-4 py-2 rounded-full text-xs uppercase tracking-wider font-semibold">
              {t('hero.label')}
            </span>
          </div>
          
          {/* Main Title */}
          <h1 className="text-6xl md:text-8xl font-serif font-bold text-white mb-4">
            {t('hero.title')}
          </h1>
          
          {/* Subtitle */}
          <h2 className="text-2xl md:text-4xl font-serif italic text-sage-200 mb-6">
            {t('hero.subtitle')}
          </h2>
          
          {/* Tagline */}
          <p className="text-lg md:text-xl text-white/90 mb-12 leading-relaxed max-w-3xl mx-auto">
            {t('hero.tagline')}
          </p>
          
          {/* Description */}
          <p className="text-base md:text-lg text-white/80 mb-12 leading-relaxed max-w-2xl mx-auto" dangerouslySetInnerHTML={{ __html: t('hero.description') }} />
          
          {/* CTA Button */}
          <Button 
            size="xl" 
            onClick={scrollToReserve}
            className="bg-gold-500 text-white hover:bg-gold-600 px-12 py-4 text-lg"
          >
            {t('hero.cta')}
          </Button>
          
          {/* Contact Number */}
          <div className="mt-6">
            <a 
              href="tel:+34643939427" 
              className="inline-flex items-center text-white/90 hover:text-white text-lg font-medium transition-colors cursor-pointer"
            >
              <i className="ri-phone-line mr-2 text-xl"></i>
              +34 643 939 427
            </a>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-2xl text-white/70"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
